import { constant } from "../Constant";

export const ErrorMessage = {
  MaxCharacterLimit: `Character limit exceeded! You can only enter up to ${constant.max_character_count} characters.`,
  ImageError: "Images are not allowed.",
  MaxCharacterLimitAndImageError: `Character limit exceeded! You can only enter up to ${constant.max_character_count} characters, and images are not allowed.`,
};
